import React from 'react';
import Experience from '../components/pages/Experience';

const ExperiencePage = (props) => {
    
    return <Experience />;
};

export default ExperiencePage;